import { render, staticRenderFns } from "./ObserveMain.vue?vue&type=template&id=0f98947a"
import script from "./ObserveMain.vue?vue&type=script&lang=js"
export * from "./ObserveMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports